import styled from 'styled-components'
import supportsWebP from 'supports-webp'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import * as sessionUserSelector from 'selectors/sessionUser'

import MainBackground4KWebp from 'assets/img/MainBG3840x2160.webp'
import MainBackground4KJpg from 'assets/img/MainBG3840x2160.jpg'
import MainBackground2KWebp from 'assets/img/MainBG2560x1440.webp'
import MainBackground2KJpg from 'assets/img/MainBG2560x1440.jpg'
import MainBackgroundFHDWebp from 'assets/img/MainBG1920x1080.webp'
import MainBackgroundFHDJpg from 'assets/img/MainBG1920x1080.jpg'

import Notification from 'components/Shared/Notification/Index'
import Footer from 'components/App/Footer/Index'
import colors from 'components/utils/colors'
import TicketProvidersList from './TicketProvidersList'

const StyledMain = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

const HeaderPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 140px;
  padding-top: 45px;
  box-sizing: border-box;
  background-color: #FFF;
`

const GreetingLine = styled.h1`
  font-size: 37px;
  line-height: 51px;
  margin-bottom: 2px;
`
const Greeting = styled.span`
  font-weight: 300;
  color: ${colors.secondary20};
`
const UserName = styled.span`
  color: #171717;
  margin-left: 14px;
`
const Subheader = styled.div`
  font-size: 14px;
  color: ${colors.secondary20};
  text-align: center;
  line-height: 22px;
  font-weight: 400;
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  justify-content: center;
  align-items: center;
  @media (max-width: 1920px) {
    background-image: url(${supportsWebP ? MainBackgroundFHDWebp : MainBackgroundFHDJpg});
  }
  @media (min-width: 1921px) and (max-width: 2560px) {
    background-image: url(${supportsWebP ? MainBackground2KWebp : MainBackground2KJpg});
  }
  @media (min-width: 2561px) {
    background-image: url(${supportsWebP ? MainBackground4KWebp : MainBackground4KJpg});
  }
  background-color: #F0F0F0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-top: 1px solid ${colors.secondary70};
`

const TicketProvidersListPage = () => {
  const userDisplayName = useSelector(sessionUserSelector.displayName)
  const ticketProviders = useSelector(sessionUserSelector.ticketProviders)
  const { t } = useTranslation()

  return (
    <StyledMain>
      <Notification />

      <HeaderPanel>
        <GreetingLine>
          <Greeting>{t('ticketProvidersListPage.greeting')}</Greeting>
          <UserName>{userDisplayName}</UserName>
        </GreetingLine>
        <Subheader>{t('ticketProvidersListPage.selectTicketProvider')}</Subheader>
      </HeaderPanel>

      <StyledContent>
        <TicketProvidersList ticketProviders={ticketProviders} />
      </StyledContent>

      <Footer />
    </StyledMain>
  )
}

export default TicketProvidersListPage
